import template from './preroll.html';
import controller from './preroll.controller';
import './preroll.scss';

export default {
  require: {
    API: '^videogular'
  },
  restrict: 'E',
  bindings: {
    lockControls: '=',
    region: '<',
    category: '<',
    onComplete: '&',
    onSkipped: '&'
  },
  template,
  controller,
  controllerAs: 'vm'
};



/** WEBPACK FOOTER **
 ** ./client/app/components/common/preroll/preroll.component.js
 **/